var a = /* @__PURE__ */ ((e) => (e.DailyCheckIn = "dailyCheckIn", e.AccountHeaderToken = "accountHeaderTokens", e.AllToken = "allTokens", e.VipShop = "vipShop", e.Unspecified = "", e))(a || {});
export {
  a as SupportTokenAction
};
//# sourceMappingURL=config.js.map
